var exports = {
  "c": "Divider__hkFvDn",
};

module.exports = exports;
